module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"my_gear":"My gear","new_item":"New item","public_library":"Public library","add_item":"Add gear","import":"Import items"},"de":{"my_gear":"Meine Ausrüstung","new_item":"Neuer Gegenstand","public_library":"Öffentliche Bibliothek","add_item":"Gegenstände hinzufügen","import":"Importieren"}}')
  delete Component.options._Ctor
}
